export default {
    timezone(state) {
        return state.timezone;
    },
};